/**
 * Rarest Watches — display-only currency converter (shop currency remains AED).
 * Converts [data-rw-money][data-aed-cents] amounts using localStorage key rw_currency.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'rw_currency';
  var AED_PER_USD = 3.6725;

  // Amount in foreign currency = AED / AED_PER_UNIT
  // Pegs / fallbacks relative to USD where noted.
  var RATES = {
    AED: 1,
    SAR: AED_PER_USD / 3.75, // SAR peg ~3.75 per USD
    USD: AED_PER_USD,
    GBP: 4.65,
    CAD: AED_PER_USD / 1.36,
    AUD: AED_PER_USD / 1.52,
    QAR: AED_PER_USD / 3.64,
    KWD: AED_PER_USD / 0.308,
    BHD: AED_PER_USD / 0.376,
    OMR: AED_PER_USD / 0.3845,
    JPY: AED_PER_USD / 150,
    CNY: AED_PER_USD / 7.25
  };

  // All display currencies: whole numbers only (half-up).
  var DECIMALS = {
    AED: 0,
    SAR: 0,
    USD: 0,
    GBP: 0,
    CAD: 0,
    AUD: 0,
    QAR: 0,
    KWD: 0,
    BHD: 0,
    OMR: 0,
    JPY: 0,
    CNY: 0
  };

  function getCurrency() {
    var stored = null;
    try {
      stored = localStorage.getItem(STORAGE_KEY);
    } catch (e) {}
    if (stored && RATES[stored]) return stored;
    return 'AED';
  }

  function setCurrency(code) {
    if (!RATES[code]) return;
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch (e) {}
  }

  function formatNumber(value, decimals) {
    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function convertCents(aedCents, currency) {
    var aed = Number(aedCents) / 100;
    if (!isFinite(aed)) return 0;
    var rate = RATES[currency] || 1;
    return aed / rate;
  }

  function formatMoney(aedCents, currency, varies) {
    var amount = convertCents(aedCents, currency);
    var decimals = DECIMALS[currency] != null ? DECIMALS[currency] : 2;
    // No decimals for any display currency.
    // .0–.4 stay / floor; .5–.9 round up (e.g. 1100.4→1100, 1100.5→1101)
    amount = Math.round(amount);
    decimals = 0;
    var formatted = formatNumber(amount, decimals);
    var text = currency + ' ' + formatted;
    if (varies) return 'From ' + text;
    return text;
  }

  function updatePrices(currency) {
    var nodes = document.querySelectorAll('[data-rw-money][data-aed-cents]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cents = el.getAttribute('data-aed-cents');
      if (cents === null || cents === '') continue;
      var varies = el.hasAttribute('data-price-varies');
      el.textContent = formatMoney(cents, currency, varies);
    }
  }

  function syncSelects(currency) {
    var selects = document.querySelectorAll('[data-rw-currency-select]');
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].value !== currency) {
        selects[i].value = currency;
      }
    }
  }

  function apply(currency) {
    setCurrency(currency);
    syncSelects(currency);
    updatePrices(currency);
    document.documentElement.setAttribute('data-rw-currency', currency);
  }

  function onSelectChange(e) {
    var code = e.target.value;
    if (!RATES[code]) return;
    apply(code);
  }

  function bindSelects() {
    var selects = document.querySelectorAll('[data-rw-currency-select]');
    for (var i = 0; i < selects.length; i++) {
      selects[i].removeEventListener('change', onSelectChange);
      selects[i].addEventListener('change', onSelectChange);
    }
  }

  function init() {
    bindSelects();
    apply(getCurrency());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for theme hooks / dynamic sections
  window.RWCurrency = {
    apply: apply,
    get: getCurrency,
    rates: RATES
  };
})();
